module.exports = __webpack_public_path__ + "static/media/competition-image.1f4dacef.png";